<template>
    <div class="wrapper">
        <alert-banners-react />
    </div>
</template>

<script>
import AlertBannersReact from './AlertBannersReact.vue';

export default {
    components: {
        AlertBannersReact,
    },
};
</script>

<style lang="scss" scoped>
@import 'styles.module';
</style>
